module.exports = __webpack_public_path__ + "img/brn.1b799733.gif";